

































import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { DocumentModule } from "@/store/modules/document.store";
import { PartnerModule } from "@/store/modules/partner";
import { SignRequestModule } from "@/store/modules/sign-request.store";
import { UserModule } from "@/store/modules/me-user.store";
import { Component } from "vue-property-decorator";
import SignRequestTable from "./SignRequestTable.vue";
import DocumentTable from "./DocumentTable.vue";
import StatisticsCardRow, { IStatisticRowElement } from "@/components/utility/StatisticsCardRow.vue";

@Component({
  components: {
    TheLayoutPortal,
    StatisticsCardRow,
    DocumentTable,
    SignRequestTable
  }
})
export default class DigitalSignatureHomeView extends PartnerFallbackMixin {
  loading = false;
  tab = 0;

  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  get items() {
    const items = [];

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN, PartnerModule.partner.id))
      items.push("sign.DigitalSignatureHomeView.showAllSignatures");

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT, PartnerModule.partner.id))
      items.push("sign.DigitalSignatureHomeView.showAllDocuments");

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT, PartnerModule.partner.id))
      items.push("sign.DigitalSignatureHomeView.showAllTemplates");

    return items;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get allDocuments() {
    return DocumentModule.documents;
  }

  get allSignatureRequests() {
    return SignRequestModule.requests;
  }

  get rowData(): IStatisticRowElement[] {
    return [
      {
        icon: "mdi-file-document-multiple-outline",
        title: "sign.DigitalSignatureHomeView.statistic.documentCount",
        color: "primary",
        data: this.allDocuments.length.toString(),
        tooltip: "sign.DigitalSignatureHomeView.statistic.documentCountHint",
        display: UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT),
        click: () => {
          this.tab = 1;
        }
      },
      {
        icon: "mdi-form-textarea",
        title: "sign.DigitalSignatureHomeView.statistic.templateCount",
        color: "primary",
        data: this.allDocuments.filter(d => d.isTemplate).length.toString(),
        tooltip: "sign.DigitalSignatureHomeView.statistic.templateCountHint",
        display: UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT),
        click: () => {
          this.tab = 2;
        }
      },
      {
        icon: "mdi-signature",
        title: "sign.DigitalSignatureHomeView.statistic.signatureRequestCount",
        color: "primary",
        data: this.allSignatureRequests.length.toString(),
        tooltip: "sign.DigitalSignatureHomeView.statistic.signatureRequestCountHint",
        display: UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN),
        click: () => {
          this.tab = 0;
        }
      },
      {
        icon: "mdi-signature-freehand",
        title: "sign.DigitalSignatureHomeView.statistic.signatureCount",
        color: "primary",
        data: this.allSignatureRequests.filter(s => s.status !== "signed").length.toString(),
        tooltip: "sign.DigitalSignatureHomeView.statistic.signatureCountHint",
        display: UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN),
        click: () => {
          this.tab = 0;
        }
      }
    ];
  }

  async mounted() {
    try {
      this.setTab();

      this.loading = true;
      await this.trySetByRouteOrDefault();

      const promises: Promise<void>[] = [];

      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN)) {
        promises.push(DocumentModule.getAll({ partnerId: PartnerModule.partner._id }));
      }

      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN)) {
        promises.push(SignRequestModule.getAll({ partnerId: PartnerModule.partner._id }));
      }

      await Promise.all(promises);
    } catch (e) {
      this.$toast.error((e as any).message);
      this.$log.error(e);
    } finally {
      this.loading = false;
    }
  }

  get tabs() {
    const tabOptions: string[] = [];
    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN)) {
      tabOptions.push(ResourceEnum.SIGN);
    }
    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT)) {
      tabOptions.push(ResourceEnum.DOCUMENT);
    }

    return tabOptions;
  }

  setTab() {
    if (this.$route.params?.tab) {
      this.tab = this.tabs.indexOf(this.$route.params.tab);
    }
  }
}
